var map = {
	"./zapsplat_office_pen_biro_ball_point_tap_001_49692.wav": 137,
	"./zapsplat_office_pen_biro_ball_point_tap_002_49693.wav": 138,
	"./zapsplat_office_pen_biro_ball_point_tap_003_49694.wav": 139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;